import React, { Component, Fragment } from 'react';

class IndexLayout extends Component {
  render() {
    return (
      <Fragment>
        {this.props.children}
      </Fragment>
    );
  }
}

export default IndexLayout;